export default __webpack_public_path__ + "static/document-d9272e6f5d06cfae1ff8ae4b49b42804.gif";